import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'
import { Liquid } from "liquidjs"

export default class extends Controller {
  static targets = [
    'visibleOnNew',
    'select',
    'hiddenOnNew',
    'cancelButton',
    'disabled',
    'noResults',
    'optionTemplate',
    'optionCreateTemplate',
  ]
  static values = {
    create: { type: Boolean, default: false },
    maxItems: { type: Number, default: 1 },
    options: { type: Array, default: [] },
    dropdownStyling: String
  }

  connect () {
    if (this.tomSelect?.classList?.contains('tomselected')) return
    if (!this.hasNoResultsTarget) throw new Error("'noResults' target must be set")
    if (!this.hasOptionTemplateTarget) throw new Error("'optionTemplate' target must be set")
    if (this.createValue && !this.hasOptionCreateTemplateTarget) {
      throw new Error("'optionCreateTemplate' target must be set when createValue is true")
    }

    this.noResults = this.noResultsTarget
    this.optionTemplate = this.optionTemplateTarget
    this.optionCreateTemplate = this.hasOptionCreateTemplateTarget && this.optionCreateTemplateTarget

    const liquideEngine = new Liquid()
    const tomSelectConfig = {
      create: this.createValue,
      maxItems: this.maxItemsValue,
      searchField: ['title', 'subtitle', 'text'],
      dropdownClass: this.dropdownStylingValue,
      ...(this.optionsValue.length > 0 && { options: this.optionsValue }),
      render: {
        no_results: (_data, _escape) => this.noResults,
        item: function(data, escape) {
          const text = data.text || data.title || data.subtitle
          return `<div>${escape(text)}</div>`
        },
        option: (data, _) => liquideEngine.parseAndRenderSync(
          this.optionTemplate.innerHTML, { data }
        ),
        option_create: (data, _) => liquideEngine.parseAndRenderSync(
          this.optionCreateTemplate.innerHTML, { data }
        )
      }
    }

    this.tomSelect = new TomSelect(this.selectTarget, tomSelectConfig)

    this.onNewValueAdded()
  }

  reset (e) {
    e.preventDefault()
    this.onExistingValue()
    this.tomSelect.clear()
  }

  onNewValueAdded () {
    if (this.hasVisibleOnNewTarget) {
      this.tomSelect.on('change', (_value) => {
        if (this.hasDisabledTarget) {
          this.disabledTarget.disabled = false
        }
      })
      this.tomSelect.on('option_add', (_value) => this.onNewValue())
      this.tomSelect.on('option_remove', (_value) => this.onExistingValue())
      this.tomSelect.on('clear', (_value) => {
        if (this.hasDisabledTarget) {
          this.disabledTarget.disabled = true
        }
        this.onExistingValue()
      })
    }
  }

  onNewValue () {
    this.visibleOnNewTargets.forEach(target => {
      target.classList.remove('hidden')
    })

    this.hiddenOnNewTargets.forEach(target => {
      target.classList.add('hidden')
    })
  }

  onExistingValue () {
    this.visibleOnNewTargets.forEach(target => {
      target.classList.add('hidden')
    })

    this.hiddenOnNewTargets.forEach(target => {
      target.classList.remove('hidden')
    })
  }

  disconnect () {
    this.tomSelect.destroy()
  }
}
